module.exports = __webpack_public_path__ + "img/share-icon.a17f5fc9.svg";